import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import { AfterpayLogo } from "@/components/AfterpayMessage";

export default function Footer() {
  const { content } = useContent();
  const tagline = content.footer?.tagline ||
    "Handcrafted wooden boards and resin platters made in small batches in the workshop. One maker. One pair of hands. Built to outlive trends.";

  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#00332B] bg-[#004D40] mt-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <p className="font-display !text-[#E0F2F1] text-3xl mb-4">David&apos;s</p>
          <p className="text-[#B2DFDB] max-w-md leading-relaxed">{tagline}</p>
        </div>
        <div>
          <p className="smallcaps mb-4 !text-[#4DD0C1]">Shop</p>
          <ul className="space-y-2 text-[#B2DFDB]">
            <li><Link to="/shop" className="hover:text-white">All Pieces</Link></li>
            <li><Link to="/category/chopping-boards" className="hover:text-white">Chopping Boards</Link></li>
            <li><Link to="/category/resin-platters" className="hover:text-white">Resin Platters</Link></li>
            <li><Link to="/category/furniture" className="hover:text-white">Furniture</Link></li>
            <li><Link to="/category/miscellaneous" className="hover:text-white">Miscellaneous</Link></li>
            <li><Link to="/custom-order" className="hover:text-white">Commission</Link></li>
          </ul>
        </div>
        <div>
          <p className="smallcaps mb-4 !text-[#4DD0C1]">Workshop</p>
          <ul className="space-y-2 text-[#B2DFDB]">
            <li><Link to="/workshops" className="hover:text-white">Resin Workshops</Link></li>
            <li><Link to="/about" className="hover:text-white">The Maker</Link></li>
            <li><Link to="/care" className="hover:text-white">Care Guide</Link></li>
            <li><Link to="/admin/login" className="hover:text-white">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#00332B] py-6 px-6 text-xs text-[#80CBC4] tracking-widest uppercase flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
        <span>© {new Date().getFullYear()} David&apos;s Chopping Boards — Made with patience</span>
        <span className="flex items-center gap-2 normal-case tracking-normal">
          <span className="text-[#B2DFDB] text-[11px]">We accept</span>
          <span className="px-2 py-1 rounded bg-white text-[#1A1F71] text-[11px] font-black tracking-tight" aria-label="Visa">VISA</span>
          <span className="px-2 py-1 rounded bg-white text-[#EB001B] text-[11px] font-black tracking-tight" aria-label="Mastercard">MC</span>
          <AfterpayLogo height={16} />
        </span>
      </div>
    </footer>
  );
}
